module.exports = "/templates/customer.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/customer.html
// module id = 441
// module chunks = 0